export default __webpack_public_path__ + "static/media/efefef-pencil-18px.434a0924.svg";